import { core } from '@tock/coretypes';

export function getAmountDue(purchase: core.PastPurchase | core.PurchaseOrder): number {
  const netAmountPaidCents = purchase.netAmountPaidCents ?? 0;
  const totalPrice = purchase.totalPrice ?? 0;
  const tockGiftCardBalanceUsedCents = purchase.tockGiftCardBalanceUsedCents ?? 0;

  if (isPastPurchase(purchase) && purchase.cancelledOrRefunded) {
    return 0;
  }

  if (isPastPurchase(purchase)) {
    return totalPrice - netAmountPaidCents;
  } else {
    return totalPrice - netAmountPaidCents - tockGiftCardBalanceUsedCents;
  }
}

/**
 * Placeholder for now, this assumes that the entire hold amount is always due.
 *
 * TODO: Re-examine this with edits.
 */
export function getHoldAmountDue(purchase: core.PastPurchase | core.PurchaseOrder): number {
  if (purchase.ticketPriceInformation?.priceType !== 'PAYMENT_CARD_HOLD') {
    return 0;
  }

  return (purchase.ticketPriceInformation?.amountCents ?? 0) * purchase.ticketCount;
}

/**
 * type guard for past purchase vs purchase order
 */
export function isPastPurchase(
  purchase: core.PastPurchase | core.PurchaseOrder
): purchase is core.PastPurchase {
  return (purchase as core.PastPurchase).purchaseTimestamp !== undefined;
}
